/**
 * @desc stockOccupyForBill
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(
  body: defs.tms.StockOccupyForBillRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/stockOccupy/stockOccupyForBill`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
